import { Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { supportEmail } from '../../../../../misc/globals';

export const CombinedSupportMessage = ({ message }: { message: string }) => {
  const { t } = useTranslation();

  return (
    <Typography>
      {message} {t('company:CONTACT_SUPPORT')}
      <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>.
    </Typography>
  );
};
